import "core-js/modules/es.array.push.js";
import axios from "../../store/interface";
import store from "../../store";
import { message } from "ant-design-vue";
import { DatabaseOutlined, ProjectOutlined, UserOutlined, BugOutlined, InteractionOutlined, FileImageOutlined, ToolOutlined, NotificationOutlined, UsergroupAddOutlined, AlignLeftOutlined, HomeOutlined, SoundOutlined, MessageOutlined, DownOutlined, SwapOutlined, AimOutlined, AuditOutlined, ClearOutlined, QuestionCircleOutlined, SoundFilled, GlobalOutlined, FileTextOutlined } from "@ant-design/icons-vue";
import { setItemToCookie, removeCookieItem } from "../../utils/url-tools";
import dotsConfig from "../../config/url-config";
export default {
  components: {
    DatabaseOutlined,
    ProjectOutlined,
    UserOutlined,
    BugOutlined,
    InteractionOutlined,
    FileImageOutlined,
    ToolOutlined,
    NotificationOutlined,
    QuestionCircleOutlined,
    UsergroupAddOutlined,
    AlignLeftOutlined,
    HomeOutlined,
    SoundOutlined,
    MessageOutlined,
    DownOutlined,
    SwapOutlined,
    AimOutlined,
    AuditOutlined,
    ClearOutlined,
    SoundFilled,
    GlobalOutlined,
    FileTextOutlined
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    const orcpersonInfo = JSON.parse(localStorage.ocrPersonInfo || "{}");
    return {
      showFooter: false,
      selectedKeys: [],
      collapsed: false,
      person: orcpersonInfo,
      openKeys: [],
      subMenu: "",
      isCustom: orcpersonInfo.role == "50",
      //验收人
      isPM: orcpersonInfo.role == "20" || orcpersonInfo.role == "10",
      //PM and BM
      isTagger: orcpersonInfo.role == "40",
      //终端人
      isAdmin: orcpersonInfo.role == "01",
      //管理员
      isSupplier: orcpersonInfo.role == "30",
      //供应商
      msgCount: 0,
      visible: false,
      ddAccount: "",
      isRouterAlive: true,
      language: "zhCN",
      privateDeploy: process.env.VUE_APP_PRIVATE_CUSTOM === "1",
      heartTimer: null,
      docmentList: []
    };
  },
  created() {
    const lang = localStorage.getItem("lang") || "zhCN";
    this.language = lang;
    this.getDocList();
  },
  mounted() {
    const {
      k,
      m
    } = this.setMenu(this.$route);
    this.selectedKeys = [k];
    this.openKeys.push(m);
    if (!this.isTagger) {
      // this.getMsg()
    } else {
      // this.getTagMsg()
    }
    if (this.heartTimer) {
      clearInterval(this.heartTimer);
    } else {
      this.heartTimer = setInterval(() => {
        this.sendHeart();
        console.log("发送心跳------------------");
      }, 600 * 1000); // 10分钟发一次
    }
    this.showFooter = this.$route.path.indexOf('/home/index') > -1;
  },
  updated() {
    const {
      k,
      m
    } = this.setMenu(this.$route);
    this.selectedKeys = [k];
    this.openKeys.push(m);
    this.showFooter = this.$route.path.indexOf('/home/index') > -1;
  },
  methods: {
    getDocList() {
      axios({
        method: "get",
        url: process.env.VUE_APP_BASE_URL + "manage/project/wordlistByRole"
      }).then(res => {
        if (res.data.code == 200) {
          this.docmentList = res.data.data || [];
        }
      });
    },
    onLanguageChange(language) {
      localStorage.setItem("lang", language);
      this.setLanguageToCookie(language);
      location.reload();
    },
    onClickMenu(val) {
      const {
        key
      } = val;
      localStorage.projectPage = 1;
      if (key == "100") {
        this.$router.push("/home");
      }
      if (key == "1") {
        this.$router.push("/project/index");
      }
      if (key == "101") {
        this.$router.push("/project/new/0");
      }
      if (key == "102") {
        this.$router.push("/project/release");
      }
      if (key == "103") {
        this.$router.push("/project/going");
      }
      if (key == "104") {
        this.$router.push("/project/finish");
      }
      if (key == "2") {
        this.$router.push("/person");
      }
      if (key == "201") {
        this.$router.push("/person/tagger");
      }
      if (key == "202") {
        this.$router.push("/person/checker");
      }
      if (key == "203") {
        this.$router.push("/person/supplier");
      }
      if (key == "204") {
        this.$router.push("/person/pm");
      }
      if (key == "401") {
        this.$router.push("/algorithm/list");
      }
      if (key == "402") {
        this.$router.push("/algorithm/call");
      }
      if (key == "4") {
        this.$router.push("/errorType");
      }
      if (key == "5") {
        this.$router.push("/log");
      }
      if (key == "6") {
        this.$router.push("/document");
      }
      if (key == "51") {
        this.$router.push("/notice");
      }
      if (key == "7") {
        this.$router.push("/picture/reason");
      }
      if (key == "9") {
        this.$router.push("/person/group");
      }
      if (key == "10") {
        this.$router.push("/baseConfig/index");
      }
      if (key == "13") {
        this.$router.push("/baseConfig/tagRule");
      }
      if (key == "15") {
        this.$router.push("/toolConfig");
      }
      if (key == "16") {
        this.$router.push("/model/management");
      }
      if (key == "17") {
        this.$router.push("/regionFrameType/index");
      }
      // 管理员
      if (key == "21") {
        this.$router.push("/admin");
      }
      // 终端人
      if (key == "1001") {
        this.$router.push("/tag");
      }
      if (key == "1003") {
        this.$router.push("/tag/going");
      }
      // 供应商
      if (key == "2001") {
        this.$router.push("/supplier");
      }
      if (key == "206" || key == "2003") {
        this.$router.push("/supplier/tagger");
      }
      // 验收人
      if (key == "3001") {
        this.$router.push("/checkout");
      }
    },
    setMenu(route) {
      const path = route.path;
      let k = "";
      let m = "";
      switch (path) {
        case "/home/index":
          k = "100";
          break;
        case "/project/index":
          k = "1";
          m = "sub1";
          break;
        case "/project/new/0":
          k = "101";
          m = "sub1";
          break;
        case "/project/release":
          k = "102";
          m = "sub1";
          break;
        case "/project/going":
          k = "103";
          m = "sub1";
          break;
        case "/project/finish":
          k = "104";
          m = "sub1";
          break;
        case "/person/index":
          k = "2";
          m = "sub2";
          break;
        case "/person/tagger":
          k = "201";
          m = "sub2";
          break;
        case "/person/checker":
          k = "202";
          m = "sub2";
          break;
        case "/person/supplier":
          k = "203";
          m = "sub2";
          break;
        case "/algorithm/list":
          k = "401";
          m = "sub4";
          break;
        case "/algorithm/call":
          k = "402";
          m = "sub4";
          break;
        case "/errorType/index":
          k = "4";
          m = "sub3";
          break;
        case "/log/index":
          k = "5";
          break;
        case "/document/management":
          k = "6";
          break;
        case "/document/manual":
          k = `${route.query.url}-${route.query.id}`;
          m = "sub8";
          break;
        case "/notice/index":
          k = "51";
          break;
        case "/picture/reason":
          k = "7";
          m = "sub3";
          break;
        case "/person/group":
          k = "9";
          m = "sub2";
          break;
        case "/baseConfig/index":
          k = "10";
          m = "sub3";
          break;
        case "/baseConfig/tagRule":
          k = "13";
          m = "sub3";
          break;
        case "/toolConfig":
          k = "15";
          m = "sub3";
          break;
        case "/model/management":
          k = "16";
          m = "sub3";
          break;
        case "/regionFrameType/index":
          k = "17";
          m = "sub3";
          break;
        // 管理员
        case "/admin":
          k = "21";
          break;
        // 终端人
        case "/tag/index":
          k = "1001";
          break;
        case "/tag/going":
          k = "1003";
          break;
        // 供应商
        case "/supplier/index":
          k = "2001";
          break;
        case "/supplier/tagger":
          k = "2003";
          // k = '206'
          // m = 'sub2'
          break;
        // 供应商
        case "/checkout/index":
          k = "3001";
          break;
      }
      this.subMenu = m;
      return {
        k,
        m
      };
    },
    showDingDing() {
      this.ddAccount = this.person.ding_talk_account;
      this.visible = true;
    },
    handleOk() {
      const promise = new Promise((resolve, reject) => {
        axios({
          method: "POST",
          url: process.env.VUE_APP_BASE_URL + "manage/auth/bindding",
          data: {
            account: this.person.account,
            ding_talk_account: this.ddAccount
          }
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        if (result.code == 200) {
          message.success(lang("save_success"));
          this.person.ding_talk_account = this.ddAccount;
          this.visible = false;
        }
      });
    },
    //返回一体化平台
    goIntegratedPlatform() {
      if (this.privateDeploy || process.env.VUE_APP_CONTAIN_LOGIN === "1") {
        return;
      }
      const url = dotsConfig.dotsUrl ? dotsConfig.dotsUrl : process.env.VUE_APP_INTEGRATED_URL;
      location.href = url + "/admin/home";
    },
    exitLogin() {
      const promise = new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BASE_URL + "api/users/logout"
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        if (result.code == 200) {
          // 清空筛选
          this.$store.dispatch("select/clearSelect");

          // localStorage.removeItem('token')
          // localStorage.removeItem('ocrPersonInfo')
          localStorage.clear();
          message.success(lang("exit_success"));
          const url = dotsConfig.dotsUrl ? dotsConfig.dotsUrl : process.env.VUE_APP_INTEGRATED_URL;
          location.href = url + "/login";
        }
      });
    },
    getMsg() {
      const promise = new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BASE_URL + "manage/home/noreadcount"
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        if (result.code == 200) {
          // console.log(result);
          this.msgCount = result.data.count;
        }
      });
    },
    getTagMsg() {
      const promise = new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BASE_URL + "api/messages/unread_count"
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        if (result.code == 200) {
          // console.log(result);
          this.msgCount = result.data.unread;
        }
      });
    },
    toDocment(e, item) {
      this.selectedKeys = item.url;
      this.$router.push({
        path: "/document/manual",
        query: {
          url: item.url,
          id: item.id
        }
      });
      e.stopPropagation();
    },
    gotoMessage() {
      this.$router.push({
        name: "homeMessage"
      });
    },
    gotoTagMessage() {
      this.$router.push({
        name: "tagMessage"
      });
    },
    reload(sub, val) {
      // console.log(sub);
      // console.log(val);
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
        this.openKeys = [sub];
        this.selectedKeys = [val];
        // console.log(this.openKeys)
        // console.log(this.selectedKeys)
      });
      // this.getMsg()
    },
    goToOld() {
      window.location.href = process.env.VUE_APP_Front_URL + "?token=" + localStorage.token;
    },
    sendHeart() {
      const promise = new Promise((resolve, reject) => {
        axios({
          method: "POST",
          url: process.env.VUE_APP_BASE_URL + "api/active_ping"
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        // if (result.code == 200) {
        //   resolve(result.data)
        // }
      });
    },
    setLanguageToCookie(lang) {
      let resLang = "zh_CN";
      if (lang === "enUS") {
        resLang = "en_US";
      }
      setItemToCookie("languageType", resLang, null, "/", "", null);
    }
  }
};